import { render } from "./detail-fields.vue?vue&type=template&id=2c135e27&scoped=true&ts=true"
import script from "./detail-fields.vue?vue&type=script&lang=ts"
export * from "./detail-fields.vue?vue&type=script&lang=ts"

import "./detail-fields.vue?vue&type=style&index=0&id=2c135e27&scoped=true&lang=css"
import "./detail-fields.vue?vue&type=style&index=1&id=2c135e27&lang=css"

import exportComponent from "C:\\agent\\_work\\44\\s\\DesignReg.VueClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c135e27"]])

export default __exports__